var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 497 497",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f9f8f9",
    d: "M386 144.047V408c0 22.091-17.909 40-40 40H71c-22.091 0-40-17.909-40-40V40C31 17.909 48.909 0 71 0h171.197c4.547 0 8.987 1.032 13.007 2.966 3.025 1.455 126.621 125.409 128.09 128.629A29.992 29.992 0 0 1 386 144.047z",
    "data-original": "#f9f8f9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e0e4",
    d: "M386 144.05v17.59H281.68c-31.45 0-57.04-25.62-57.04-57.1V0h17.56c4.344 0 8.593.944 12.472 2.719 3.228 1.477 127.222 125.755 128.696 129.037A30.011 30.011 0 0 1 386 144.05z",
    "data-original": "#e3e0e4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e0e4",
    d: "M386 144.05v17.59H281.68c-31.45 0-57.04-25.62-57.04-57.1V0h17.56c7.96 0 15.6 3.17 21.23 8.81l113.81 114.05a29.989 29.989 0 0 1 8.76 21.19z",
    "data-original": "#e3e0e4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e0e4",
    d: "M386 144.05v17.59H281.68c-31.45 0-57.04-25.62-57.04-57.1V0h17.56c4.344 0 8.593.944 12.472 2.719 3.228 1.477 127.222 125.755 128.696 129.037A30.011 30.011 0 0 1 386 144.05zM101 448H71c-22.09 0-40-17.91-40-40V40C31 17.91 48.91 0 71 0h30C78.91 0 61 17.91 61 40v368c0 22.09 17.91 40 40 40z",
    "data-original": "#e3e0e4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a29aa5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.108 150h-123.7a7.5 7.5 0 0 1 0-15h123.7a7.5 7.5 0 0 1 0 15zM212.108 330h-123.7a7.5 7.5 0 0 1 0-15h123.7a7.5 7.5 0 0 1 0 15zM310.408 210h-224a7.5 7.5 0 0 1 0-15h224a7.5 7.5 0 0 1 0 15zM310.408 270h-224a7.5 7.5 0 0 1 0-15h224a7.5 7.5 0 0 1 0 15zM383.31 131.64H281.68c-14.93 0-27.04-12.14-27.04-27.1V2.72c3.24 1.46 6.23 3.52 8.79 6.09l113.81 114.05c2.55 2.56 4.61 5.54 6.07 8.78z",
    fill: "#a29aa5",
    "data-original": "#a29aa5"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 364.489,
    cy: 395.5,
    fill: "#80e29e",
    rx: 101.511,
    ry: 101.5,
    "data-original": "#80e29e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77d192",
    d: "M445.57 456.57C427.05 481.13 397.62 497 364.49 497c-56.06 0-101.51-45.44-101.51-101.5 0-33.13 15.87-62.55 40.43-81.07-12.83 16.99-20.43 38.14-20.43 61.07 0 56.06 45.45 101.5 101.51 101.5 22.93 0 44.08-7.6 61.08-20.43z",
    "data-original": "#77d192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9f8f9",
    d: "m409.755 367.873-38-21c-2.207-1.206-4.729-1.881-7.241-1.875l.001.003a14.974 14.974 0 0 0-7.27 1.871l-38 21c-7.251 4.007-9.881 13.133-5.874 20.384 4.008 7.25 13.134 9.881 20.384 5.873l15.745-8.701V431c0 8.284 6.716 15 15 15s15-6.716 15-15v-45.573l15.745 8.701c7.251 4.007 16.376 1.377 20.384-5.873 4.007-7.249 1.377-16.375-5.874-20.382z",
    "data-original": "#f9f8f9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.93cb0b6db1bcd83c6db2d063e94bc137.svg";
export { ForwardRef as ReactComponent };